<div class="chat-container" [class.active]="isActive" [class.not-my]="!isMyChat" [routerLink]="isToolbar ? toolbarRouterLink : routerLink">
  <div class="active-indicator"></div>
  <div class="chat-avatar-container">
    <div class="chat-avatar">
      <ng-container *ngIf="!this.chat?.isIndividual; else personal">
        <div class="chat-avatar-users">
          <div class="chat-avatar-users-item" *ngFor="let user of chat.users.slice(0, 4); trackBy: trackBy">
            <lin-avatar [source]="user.picture" [name]="user.name" [surName]="user.surname" [size]="AvatarSize.group"> </lin-avatar>
          </div>
        </div>
      </ng-container>
      <ng-template #personal>
        <lin-avatar
          [source]="avatarPersonal?.picture"
          [name]="avatarPersonal?.name"
          [surName]="avatarPersonal?.surname"
          [size]="AvatarSize.mds"
        >
        </lin-avatar>
      </ng-template>
    </div>
    <div class="user-status" *ngIf="this.chat?.isIndividual">
      <div class="status" [ngClass]="{ 'online': isOnline }"></div>
    </div>
  </div>
  <div class="chat-info">
    <div class="chat-message title">{{ !this.chat?.isIndividual ? chat?.name || chatTitle : avatarPersonal?.fullName }}</div>
    <div *ngIf="draftMessage?.length; else lastChatHistory" class="chat-message">
      <span class="draft">{{ 'CLIENT.MESSENGER.CHAT_LIST.DRAFT' | translate}}: </span>{{ draftMessage }}
    </div>
    <ng-template #lastChatHistory>
      <div class="chat-message">{{ chat.lastChatHistory?.message }}</div>
    </ng-template>
  </div>
  <div class="chat-last-activity">
    <div class="chat-last-activity-update-time">{{ chat.lastChatHistory?.createdAt | dayjsFullTime }}</div>
    <div class="chat-last-activity-unread-count" *ngIf="chat.unreadCount">{{ chat.unreadCount }}</div>
  </div>
</div>
